import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraRenewSecondaryRecIllustration: FunctionComponent<Props> = ({ size = 64 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M52.0174 41.4236C54.9612 34.8235 54.7625 25.132 50.5053 19.1342C47.5505 14.9716 41.7481 11.7562 36.6725 11.2167C31.3715 10.6536 25.7284 11.0818 21.0738 13.7717C16.9838 16.1354 13.526 19.6628 11.637 24.0106C10.4166 26.8197 9.87109 29.9127 10.0256 32.9696C10.3331 39.0772 13.1791 45.3385 18.4028 48.662C24.7145 52.6773 33.2494 54.3587 40.4126 51.7456C44.8322 50.1332 49.9124 46.1415 52.0158 41.4236H52.0174Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M42.9955 19.9897C47.3473 23.467 49.7251 28.7245 48.3549 34.8854C47.6643 37.9878 46.0166 40.8471 43.9668 43.2578C40.4649 47.375 36.3795 49.7653 30.8215 49.0125C25.8233 48.3364 20.3267 45.5117 17.8386 40.938C16.0411 37.6333 16.347 33.1726 17.1244 29.6138C17.7425 26.7827 18.8761 24.0614 20.4749 21.6397C21.965 19.3812 24.0825 17.83 26.5627 16.7148C29.4703 15.4083 32.7972 15.5337 35.8135 16.3807C38.516 17.1398 40.9694 18.3711 42.994 19.9897H42.9955Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M43.8653 33.329C44.2863 38.7229 40.8537 44.3082 34.3008 45.2571C23.4087 46.8334 15.7709 35.6911 23.59 26.9877C30.2896 19.5312 43.0722 23.1559 43.8653 33.329Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M32.1448 40.6765C35.6237 40.6765 38.4439 37.8711 38.4439 34.4105C38.4439 30.9499 35.6237 28.1445 32.1448 28.1445C28.6659 28.1445 25.8457 30.9499 25.8457 34.4105C25.8457 37.8711 28.6659 40.6765 32.1448 40.6765Z'
        fill={spotIllustration.primary.fill}
      />
    </Svg>
  )
}
